// Informations de contact centralisées
export const CONTACT = {
  brand: "Kiwami Studios & Co",
  phone: "+212 6 61 49 13 49",
  phoneHref: "tel:+212661491349",
  whatsappHref: "https://wa.me/212661491349",
  email: "contact@kiwamistudios.com",
  emailHref: "mailto:contact@kiwamistudios.com",
  instagramHref: "https://www.instagram.com/kiwami_studios/",
  city_fr: "Local · International",
  city_en: "Local · International",
};
